export interface CondicaoDocumentoDto {
  codigo: number;
  descricao: string;
  isSistematicaAntiga: boolean
}

export enum CondicaoDocumentoEnum {
  PAGO = 1,
  EMITIDO = 2,
  AGENDADO = 3
}